module.exports = __webpack_public_path__ + "img/orcid.logo.2af2bbf6.svg";